import { TareaEjecucionResponse } from "../modulos/rastro/response/TareaEjecucionResponse";

/** Paleta de 12 colores (hex) de alto contraste sobre satélite/vegetación
 *  (sin verdes ni amarillos), para distinguir ejecuciones superpuestas. */
const PALETA: string[] = [
  "#FF0099", "#00FFFF", "#FF0033", "#0066FF", "#CC00FF", "#00CCFF",
  "#FF00CC", "#9900FF", "#FF0066", "#0099FF", "#33CCFF", "#3333FF",
];

/** Ordena un grupo de ejecuciones (misma finca + día) por `fechaInicio` y,
 *  a igualdad, por `id` — el mismo orden estable que determina el color de
 *  cada una (no muta el array recibido). */
function ordenarParaColor(
  ejecuciones: TareaEjecucionResponse[],
): TareaEjecucionResponse[] {
  return [...ejecuciones].sort((a, b) => {
    const porFecha = a.fechaInicio.localeCompare(b.fechaInicio);
    return porFecha !== 0 ? porFecha : a.id.localeCompare(b.id);
  });
}

/** Color (hex) asignado a una ejecución dentro de su grupo (mismas
 *  finca+día, ya viene así de `DiaTareaEjecucionesBucket`): determinístico
 *  por posición (`fechaInicio`, luego `id`), cíclico sobre la paleta. */
export function colorDeEjecucion(
  ejecuciones: TareaEjecucionResponse[],
  ejecucionId: string,
): string {
  const ordenadas = ordenarParaColor(ejecuciones);
  const index = ordenadas.findIndex((e) => e.id === ejecucionId);
  return PALETA[(index < 0 ? 0 : index) % PALETA.length];
}

/** Color de texto contrastante ("#000000" o "#FFFFFF") para un color de
 *  fondo hex, según luminancia percibida. */
export function colorTextoContraste(colorHex: string): string {
  const r = parseInt(colorHex.slice(1, 3), 16);
  const g = parseInt(colorHex.slice(3, 5), 16);
  const b = parseInt(colorHex.slice(5, 7), 16);
  const luminancia = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminancia > 0.6 ? "#000000" : "#FFFFFF";
}
